















































import { Component, Prop } from 'vue-property-decorator';

import InfoIcon from '@/components/icons/InfoV2.vue';
import InputBase from './InputBase.vue';

@Component({
  components: {
    InfoIcon
  }
})
export default class InputWrapper extends InputBase {
  @Prop({ default: 'label' }) labelTag?: string;
  @Prop({ default: false }) optional?: boolean;
  @Prop({ default: true }) showHelpIcon?: boolean;
  @Prop({ default: '' }) rightLabel?: boolean;
  @Prop() tippy?: string;
  @Prop({ default: false }) rightLabelClickable?: boolean;

  get labelHtml() {
    let html = this.label;
    if (this.optional)
      html += ` <span class="input-wrapper__optional">(${this.$t(
        'common.components.inputWrapper.optional'
      )})</span>`;
    return html;
  }
}
